import {trim} from 'lodash';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal, Input} from 'components';
import {useIsChangedTo, useObservable} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';
import {authDataStore} from 'services';
import {DomainInfo} from 'types';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SETTINGS.CSP_WHITELIST;

type Props = {
    open: boolean;
    onClose: (confirm: boolean, data: DomainInfo) => void;
}

export const AddItemModal: React.FC<Props> = ({open, onClose}) => {
    const {t} = useTranslation();
    const {localUser} = useObservable(authDataStore);
    const [item, setItem] = useState('');
    const [description, setDescription] = useState('');
    const modalOpened = useIsChangedTo(open, true);
    const linkValid = useMemo(() => item?.length > 0, [item]);

    const handleAdd = useCallback((confirm: boolean) => {
        let fullInfo = null;
        if (confirm) {
            fullInfo = {
                domain: item,
                description,
                createdBy: localUser.eid,
                createdAt: new Date()
            };
        }

        onClose(confirm, fullInfo);
    }, [item, description, localUser, onClose]);

    useEffect(() => {
        if (modalOpened) {
            setItem('');
            setDescription('');
        }
    }, [modalOpened]);

    return (
        <ConfirmModal
            okDisabled={!linkValid}
            open={open}
            title={t(T_KEYS.MODAL.CREATE)}
            onClose={handleAdd}
        >
            <Input
                className='tw-mb-4'
                hasError={!!item && !linkValid}
                label={t(T_KEYS.HEADERS.DOMAIN)}
                value={item}
                onChange={(value: string) => setItem(trim(value))}
            />
            <Input
                label={t(T_KEYS.HEADERS.DESCRIPTION)}
                value={description}
                onChange={setDescription}
            />
        </ConfirmModal>
    );
};